import React, { Component, Fragment } from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import queueRequestHandler from '../../../api/queueRemote';
import ghaRequestHandler from '../../../api/ghaRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import DriverQueueInfo from '../../../models/DriverQueueInfo';

import DriverQueuePage from './DriverQueuePage';

import DriverHome from './DriverHome';
import OrderNumber from './OrderNumber';
import OrderDetailsPage from './OrderDetailsPage';
import PickupOrderGha from '../../../models/PickupOrderGha';
import { PO_SCHEMA_GHA } from '../../../utils/pickupOrder';
import CheckInSuccess from './CheckInSuccess';
import GhaDock from '../../../models/GhaDock';
import userManagementReqHandler from '../../../api/userManagementRemote';
import AirlineType from '../../../models/AirlineType';
import { receiveButtonState } from '../../../store/actions/disableApiCall';

interface MatchParams {
  ghaId: string;
};

interface DriverQueuePageContainerProps extends RouteComponentProps<MatchParams>{
  receiveError: Function;
  receiveSuccess: Function;
  setButtonState: (value: boolean) => void;
  buttonState: boolean;
};

interface DriverQueuePageContainerState {
 info: DriverQueueInfo;
 ghaId: number;
 success: boolean;
 ghaName: string;
 mandatoryFields: Array<string>;
 screen: string;
 orderNumber: string;
 po: PickupOrderGha;
 docks: GhaDock[];
 airlines: AirlineType[];
};

class DriverQueuePageContainer extends Component<DriverQueuePageContainerProps, DriverQueuePageContainerState> {

  timer: any;

  state = {
    ghaId: 0,
    info: {
      first_name: '',
      last_name: '',
      company: '',
      type: 'import' as const,
      airlines: [],
      dock: ''
    },
    success: false,
    ghaName: '',
    screen: 'home',
    orderNumber: '',
    po: PO_SCHEMA_GHA,
    docks: [],
    airlines: [],
    mandatoryFields: ['first_name', 'last_name', 'company', 'type']
  }

  componentDidMount() {

    const params: MatchParams = this.props.match.params;
    const ghaId: number = Number(params.ghaId);
    this.setState({ ghaId });
    this.getGhaName(ghaId);
    this.getGhaFlightsAndDocks(ghaId);
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  getGhaName = (ghaId: number): void => {
    ghaRequestHandler.getGhaName(ghaId).then((resp: ApiResponse<{ ghaName: string }>) => {

      const gha: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (gha) {
        let mandatoryFields = [...this.state.mandatoryFields];
        if(gha.params) {
          mandatoryFields = gha.params.mandatory_fields;
        }
        this.setState({ ghaName: gha.ghaName, mandatoryFields });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }


  getGhaFlightsAndDocks = (ghaId: number): void => {
    ghaRequestHandler.getGhaDocks(ghaId).then((resp: ApiResponse<GhaDock[]>) => {

      const gha: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (gha) {
        this.setState({ docks: gha });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
    userManagementReqHandler.getAirlines(ghaId).then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }

  handleChange = (fieldName: string, event: React.ChangeEvent<HTMLInputElement>): void => {

    const currentInfo: DriverQueueInfo = { ...this.state.info };
    const value: any = event.target.value;

    switch (fieldName) {
      case 'firstName': 
        currentInfo.first_name = value; 
        break;
      case 'lastName':
        currentInfo.last_name = value;
        break;
      case 'company':
        currentInfo.company = value;
        break;
      case 'dock':
        currentInfo.dock = value;
        break;
      case 'airline':
        currentInfo.airlines = value;
        break;
      case 'remarks':
        currentInfo.remarks = value;
        break;
      case 'type':
        if (value !=='import' && value !== 'export') {
        } else {
          currentInfo.type = value;
        }
        break;
      default: break;
    }
    this.setState({ info: currentInfo });
  }

  handleSave = (type: string): void => {
    if(type == 'walk_in') {
      this.props.setButtonState(true);
      queueRequestHandler.insertDriverInQueue(this.state.ghaId, this.state.info).then((resp: ApiResponse<boolean>) => {
        this.responseSave(resp);
      });
    } else {
      queueRequestHandler.insertDriverAppointment(this.state.ghaId, 'driver', this.state.po.number).then((resp: ApiResponse<boolean>) => {
        this.responseSave(resp);
      });
    }

  };

  changeOrderNumber = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value: string = event.target.value;
    this.setState({ orderNumber: value });
  }

  loadPoOrderAwbs = (): void => {

    queueRequestHandler.getDriverPickupOrderList(this.state.orderNumber).then((resp: ApiResponse<PickupOrderGha>) => {

      const po: PickupOrderGha | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        this.setState({ po, screen: 'order' });
      }
      
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  changeScreen = (screen: string): void => {
    this.setState({ screen });
  }

  responseSave = (resp: ApiResponse<boolean>) => {
    const success: boolean | undefined = resp.success;
    const error: ResponseError | undefined = resp.error;

    if (success) {
      this.props.setButtonState(false);
      this.setState({success,
        screen: 'success', 
        info: {
        first_name: '',
        last_name: '',
        company: '',
        dock: '',
        type: 'import' as const,
        airlines: []
      },
    }, () => {this.timer =  setTimeout(() => {
        this.setState({ success: false });
      }, 10000)});
    
    }

    if (error) {
      this.props.receiveError(error);
    }
  }

  isValid = (): boolean => {
    const { first_name, last_name, company, type, airlines } = this.state.info;
    const mandatoryFields = this.state.mandatoryFields || [];
  
    // Check if all mandatory fields are filled
    const allMandatoryFieldsFilled = mandatoryFields.every(fieldName => {
      const fieldValue = this.state.info[fieldName as keyof typeof this.state.info];
  
      // If the field is an array, check its length
      if (Array.isArray(fieldValue)) {
        return fieldValue.length > 0;
      }
  
      // Otherwise, check if the field itself is truthy
      return !!fieldValue;
    });
  
    // Check if 'type' is either 'import' or 'export'
    const validType = ['import', 'export'].includes(type);
  
    return allMandatoryFieldsFilled && validType;
  };

  render() {
    return (
      <Fragment>
        { this.state.screen === 'check_in' && 
          <DriverQueuePage 
            info={ this.state.info }
            handleChange={ this.handleChange }
            handleSave={ this.handleSave }
            ghaName={ this.state.ghaName }
            disabledButton={ !this.isValid() }
            airlines={ this.state.airlines }
            docks={ this.state.docks }
            changeScreen={ this.changeScreen }
            buttonState={ this.props.buttonState }
            mandatoryFields={ this.state.mandatoryFields }
          />
        }
        { this.state.screen === 'home' && 
          <DriverHome 
            ghaName={ this.state.ghaName }
            changeScreen={ this.changeScreen }
          />
        }
        { this.state.screen === 'appointment' && 
          <OrderNumber 
            ghaName={ this.state.ghaName }
            changeScreen={ this.changeScreen }
            orderNumber={ this.state.orderNumber }
            changeOrderNumber={ this.changeOrderNumber }
            submit={ this.loadPoOrderAwbs }
          />
        }
         { this.state.screen === 'order' && 
          <OrderDetailsPage 
            ghaName={ this.state.ghaName }
            changeScreen={ this.changeScreen }
            po={ this.state.po }
            handleSave={ this.handleSave }
          />
        }
        { this.state.screen === 'success' && 
          <CheckInSuccess 
            ghaName={ this.state.ghaName }
            changeScreen={ this.changeScreen }
          />
        }
      </Fragment>
    );
  };
};


const mapStateToProps = (state: any) => {
  return {
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setButtonState: (value: boolean) => dispatch(receiveButtonState(value)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverQueuePageContainer);